<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Empresa Parceira</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Empresa Parceira</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="Nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="Escola">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Selecione' }" v-model="filter.escolaId" class="form-control" name="escolaId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="contato">Responsável para Contato</label>
                                    <input type="text" class="form-control" name="contato" placeholder="Responsável para Contato" v-model="filter.contato" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="categoriaEmpresaParceiraId">Categoria</label>
                                    <select v-select="{ dataitem: 'CategoriaEmpresaParceira', default: 'Selecione' }" v-model="filter.categoriaEmpresaParceiraId" class="form-control" name="categoriaEmpresaParceiraId"></select>
                                </div>


                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Nome<i @click="executeOrderBy('empresa.pessoaEscola.nome')" class="fa fa-sort"></i></th>
                                    <th>Responsável para Contato<i @click="executeOrderBy('Contato')" class="fa fa-sort"></i></th>
                                    <th>Situação<i @click="executeOrderBy('statusEmpresa')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.empresa.pessoaEscola.nome }}</td>
                                    <td>{{ item.contato }}</td>
                                    <td>{{ item.statusEmpresa}}</td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Configurar Descontos" @click="openDesconto({ empresaParceiraId: item.empresaParceiraId })">
                                            <i class="fa fa-cog"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ empresaParceiraId: item.empresaParceiraId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove({ empresaParceiraId: item.empresaParceiraId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="empresaParceiraId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogDesconto" :hide-footer="true" title="Configuração de Desconto">
            <form-desconto v-if="dialogDesconto" :id="empresaParceiraId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import formDesconto from './form-desconto'

    export default {
        name: 'empresaparceira',
        mixins: [base],
        components: { formCreate, formEdit, formDesconto },
        data() {
            return {

                resources: {
                    filter: 'empresaparceira',
                    remove: 'empresaparceira'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogDesconto : false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    escolaId: "",
                    categoriaEmpresaParceiraId: ""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.empresaParceiraId = model.empresaParceiraId;
                this.dialogEdit = true;
            },
            openDesconto: function (model) {
                this.empresaParceiraId = model.empresaParceiraId;
                this.dialogDesconto = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogDesconto = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>